var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33284 4.5V9C9.33284 9.99 10.1728 10.8 11.1995 10.8H12.1328V17.1C12.1328 17.595 12.5528 18 13.0662 18C13.5795 18 13.9995 17.595 13.9995 17.1V0C11.4235 0 9.33284 2.016 9.33284 4.5ZM5.59951 6.3H4.66618V0.9C4.66618 0.405 4.24618 0 3.73285 0C3.21951 0 2.79951 0.405 2.79951 0.9V6.3H1.86618V0.9C1.86618 0.405 1.44618 0 0.932845 0C0.419512 0 -0.000488281 0.405 -0.000488281 0.9V6.3C-0.000488281 7.974 1.19418 9.369 2.79951 9.774V17.1C2.79951 17.595 3.21951 18 3.73285 18C4.24618 18 4.66618 17.595 4.66618 17.1V9.774C6.27151 9.369 7.46618 7.974 7.46618 6.3V0.9C7.46618 0.405 7.04618 0 6.53285 0C6.01951 0 5.59951 0.405 5.59951 0.9V6.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.dedf9fdb994d88dc1b2fc3fec3d7839b.svg";
export { ForwardRef as ReactComponent };